'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorCodes = exports.schemaNotFoundError = exports.rejectWithCollectionDeleted = exports.UnsuccessfulResponseException = exports.FailedRequestException = undefined;

var _wixDataErrors = require('@wix/wix-data-errors');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function rejectWithCollectionDeleted(collectionName) {
  var message = _wixDataErrors.messages.collectionDeleted(collectionName);
  return rejectWithError(message, _wixDataErrors.codes.CollectionDeleted);
}

function rejectWithError(message, code) {
  return Promise.reject((0, _wixDataErrors.wixDataError)(message, code));
}

var FailedRequestException = function FailedRequestException(reason) {
  _classCallCheck(this, FailedRequestException);

  this.reason = reason;
  this.message = reason;
};

var UnsuccessfulResponseException = function UnsuccessfulResponseException(status, responseText, message, requestId) {
  _classCallCheck(this, UnsuccessfulResponseException);

  this.message = message;
  this.status = status;
  this.responseText = responseText;
  this.requestId = requestId;
};

exports.FailedRequestException = FailedRequestException;
exports.UnsuccessfulResponseException = UnsuccessfulResponseException;
exports.rejectWithCollectionDeleted = rejectWithCollectionDeleted;
exports.schemaNotFoundError = _wixDataErrors.schemaNotFoundError;
exports.errorCodes = _wixDataErrors.codes;